import measures from 'globals/measures'
import styled from 'styled-components'
import colors from 'globals/colors'

export const ChooseCenterWrapper = styled.div`
  height: 32px;
  line-height: 32px;
  font-weight: 600;
  position: relative;
  cursor: pointer;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    display: none;
  }
`

export const ChooseCenterLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.footerColor};
  padding: 5px 15px;
  border-radius: 8px;

  & svg {
    margin-left: 8px;
  }
`

interface CentersChoicesProps {
  nbAddresses: number,
  show: boolean
}

export const CentersChoices = styled.div<CentersChoicesProps>`
  height: ${(props) => props.show ? ((props.nbAddresses * 24) + 35) : 0};
  max-height: 500px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0 24px;
  position: absolute;
  top: 30px;
  right: 0;
  overflow-y: scroll;
  z-index: 100;
  
  transition: height 300ms;
`

interface CenterChoiceProps {
  selected: boolean
}

export const CenterChoice = styled.div<CenterChoiceProps>`
  line-height: 40px;
  font-size: 16px;
  white-space: nowrap;
  
  &:hover {
    color: ${colors.waterBlue};
  }
  
  &:first-child {
    margin-top: 16px;
  }
  
  &:last-child {
    margin-bottom: 19px;
  }
  
  & > svg {
    display: none;
    margin-left: 35px;
  }
  
  ${(props) => props.selected && `
    color: ${colors.waterBlue};
    font-weight: 600;
    
    & > svg {
      display: inline;
    }
  `};
`
